module.exports = __webpack_public_path__ + "static/media/7_Peace of mind_AF.6c8e6be6.txt";